import React, { useEffect, useState } from "react";
import { SwapStage, SwapFace, SWAP_DURATION_MS } from "./styles";

/**
 * Slide + fade text animated text swap
 */
const SwapText = ({ swapKey, children, align = "start" }) => {
  const [active, setActive] = useState({ key: swapKey, content: children });
  const [exiting, setExiting] = useState(null);

  if (active.key !== swapKey) {
    setExiting(active);
    setActive({ key: swapKey, content: children });
  }

  useEffect(() => {
    if (!exiting) return undefined;
    const id = setTimeout(() => setExiting(null), SWAP_DURATION_MS);
    return () => clearTimeout(id);
  }, [exiting]);

  return (
    <SwapStage $align={align}>
      {exiting && (
        <SwapFace
          key={`out-${exiting.key}`}
          $exiting
          $align={align}
          aria-hidden="true"
        >
          {exiting.content}
        </SwapFace>
      )}
      <SwapFace key={`in-${active.key}`} $align={align}>
        {active.content}
      </SwapFace>
    </SwapStage>
  );
};

export default SwapText;
